exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".atlas-category{padding:calc(1.78571vw + 34.28571px) calc(.89286vw + 17.14286px);display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center}.atlas-category h4{margin:0}.atlas-category .icon{font-size:40px}", ""]);
